import { render, staticRenderFns } from "./createAddress.vue?vue&type=template&id=f1de7d16&scoped=true"
import script from "./createAddress.vue?vue&type=script&lang=ts"
export * from "./createAddress.vue?vue&type=script&lang=ts"
import style0 from "./createAddress.vue?vue&type=style&index=0&id=f1de7d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1de7d16",
  null
  
)

export default component.exports